import { z } from 'zod';

import { TASK_TABS } from '@/features/tasks';

/**
 * The run route's own search schema — just enough for the same `?task=`
 * drawer-opening mechanism `board.tsx` uses (research.md Decision 5), and
 * nothing this page has no use for. Deliberately not `boardSearchSchema`
 * itself: `view`/`diagram`/`labels`/`state`/`q` are board-narrowing concerns
 * this page does not have (it is scoped to exactly one execution's created
 * tasks already, with no filter row of its own).
 */
export const RUN_VIEWS = ['board', 'list'] as const;
export type RunView = (typeof RUN_VIEWS)[number];

export const runSearchSchema = z.object({
  task: z.uuid().optional().catch(undefined),
  tab: z.enum(TASK_TABS).optional().catch(undefined),
  // Which workspace file is shown beside the open task. Meaningless without
  // `task` and stripped when the drawer closes, exactly as `tab` is.
  preview: z.string().optional().catch(undefined),
  /**
   * The tasks as a board or a list. In the address rather than a device
   * preference so a shared link opens the view it was shared from; absent
   * means the board (`LinkedRunPage`).
   */
  view: z.enum(RUN_VIEWS).optional().catch(undefined),
  /**
   * One specific `linked_workflow` run of the parent — how its Executions tab
   * opens a past visit. Absent means the latest run, open or finished.
   */
  execution: z.uuid().optional().catch(undefined),
});
